function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 3"
}, /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 330,
  height: 330,
  rx: 165
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.51 112.31c0-6.49-.4-12.77-1-19.26h29l1 13.18c3.25-4.46 11.15-15.41 31.63-15.41 23.52 0 30.21 14.39 32.23 19.26C186.88 93.66 200.66 91 211.21 91c20.67 0 29 12.37 31.21 16.42 5.48 8.92 5.07 21.29 5.07 30.21v56.08h-30.2v-58.49c0-11-1.63-23.11-17.23-23.11-18.05 0-18.45 16.82-18.45 32v49.59H151.4v-59.09c0-7.91-.2-22.5-16.83-22.5-18.85 0-18.85 16.21-18.85 23.11v58.51H85.51zM84.5 216.24h163v24.94h-163z",
  fill: "#f4f4f4"
}));

function SvgMta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 332 332",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMta);
export default __webpack_public_path__ + "static/media/MTA.46b32468.svg";
export { ForwardRef as ReactComponent };